export default __webpack_public_path__ + "static/media/xx.11e97112.svg";